import styled from 'styled-components'

export const Timer = styled.div`
	position: relative;
	background-color: #f9fafb;
	padding: 1rem 2rem;
	width: 100%;
	margin-top: 2rem;
`;
